
<script setup lang="ts">
import { useCmsBlock } from "#imports";
import type { Schemas } from "#shopware";

type CmsBlockLuftkussCmsElementsCategoryTeaser = Schemas["CmsBlock"] & {
  type: "luftkuss-cms-elements-aboutus";
  slot: string;
};

const props = defineProps<{
  content: CmsBlockLuftkussCmsElementsCategoryTeaser;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const slotContent = getSlotContent("content");
</script>

<template>
  <div class="cms-text-block !m-0">
    <CmsGenericElement :content="slotContent" />
  </div>
</template>


